import React from "react";
import BinaryPickerFormField from "~/visuals/organisms/BinaryPickerFormField";
import { useChargeFormStateApi } from "./chargeFormProviders/ChargeFormStateProvider";

export const ChargeBillableToggle: React.FC = () => {
  const { fieldStates } = useChargeFormStateApi();

  return (
    <BinaryPickerFormField
      {...{
        disabled: fieldStates.billable.disabled,
        label: "Billable?",
        helperText: "",
        formField: "billable",
      }}
    />
  );
};

export const ChargeTaxableToggle: React.FC = () => {
  const { fieldStates } = useChargeFormStateApi();

  return (
    <BinaryPickerFormField
      {...{
        disabled: fieldStates.taxable.disabled,
        label: "Taxable?",
        helperText: "",
        formField: "taxable",
      }}
    />
  );
};

export const ChargeOverrideRateToggle: React.FC = () => {
  const { fieldStates } = useChargeFormStateApi();

  return (
    <BinaryPickerFormField
      {...{
        disabled: fieldStates.useCustomRate.disabled,
        formField: "useCustomRate",
        label: "Override Rate",
        helperText: "",
      }}
    />
  );
};
